import { useEffect, useMemo, useState } from "react";
import { TABLE_PAGE_SIZE } from "./TablePager";

export function usePagedRows<T>(rows: T[]) {
  const [page, setPage] = useState(1);
  const pageCount = Math.max(1, Math.ceil(rows.length / TABLE_PAGE_SIZE));
  const pageRows = useMemo(
    () => rows.slice((page - 1) * TABLE_PAGE_SIZE, page * TABLE_PAGE_SIZE),
    [page, rows]
  );

  useEffect(() => {
    setPage(1);
  }, [rows.length]);

  return {
    page,
    pageCount,
    pageRows,
    previousPage: () => setPage((current) => Math.max(1, current - 1)),
    nextPage: () => setPage((current) => Math.min(pageCount, current + 1)),
  };
}
